import React from "react";
import emailjs from "emailjs-com";
import '../styles.css'
import './Contato.css'
import { useState } from "react";
import { MdOutlineMailOutline } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io5";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Titulo from "../../components/Título/Titulo";

function Contato ({backgroundImage}){

  const [formData, setFormData] = useState({
    'name': '',
    'email': '',
    'message': ''
  })

  const handleFormData = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const sendEmail = (form) => {
    form.preventDefault();

    emailjs.sendForm(
      'service_8skhpvg',
      'template_5jw6f0a',
      form.target,
      'gZFQqqNNmRvBhrUMB'
    ).then(() => {
      setFormData({
        'name': '',
        'email': '',
        'message': ''
      });
    }).catch(error => {
      console.error("Erro ao enviar o e-mail:", error);
    });
  }

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
  };

  const {hash} = useLocation()
  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);
  
  return (
    <div>
      <Titulo title='Contato' backgroundImage={backgroundImage} position='right 45% '/>
      <section className='contact-infos'>
        <div>
          <MdOutlineMailOutline size='5vh' color="#5E7153" />
          <h1 >Email:</h1>
          <h1>maracajumg@gmail.com</h1>
          <button onClick={() => scrollToSection('form')}> Envie um email</button>
        </div>        
        <div><IoLogoWhatsapp size='5vh' color="#5E7153"/>
          <h1>Whatsapp : </h1>
          <h1>(32) 9900-2213</h1>
          <a href="https://api.whatsapp.com/send?phone=5532999002213" 
            target="_blank" rel="noopener noreferrer">
            <button>Entre em contato</button>
          </a>

        </div>        
      </section>

      <section className="form-container"  id="form">
          <form onSubmit={sendEmail}> 
            <h1>Fale com a Maracaju!</h1>
            <div>
              <label> Nome: </label>
              <input type='text' required name='name' onChange={handleFormData} value={formData.name}/>
            </div>
            <br/>
            <div>
              <label> Email: </label>
              <input type="email" required name= 'email' onChange={handleFormData} value={formData.email}/>
            </div>
            <br/>
            <div>
              <label> Mensagem: </label>
              <br/>
              <textarea name='message' required onChange={handleFormData} value={formData.message}/>
            </div>
            <br/>
            <br/>
            <button type="submit"> Enviar </button>
            <br/>

          </form>
      </section>     
    </div>
  )

}

export default Contato; 